/*
  Barlen: de kaart van een kleed bij een gekozen maat.
  - De maat komt uit het adres (?b=…&l=… of ?d=…) of uit het maatfilter (data-pi-kies op de kaart).
  - Bestaat die maat als vaste maat, dan de prijs van die maat; een maat op voorraad gaat voor, en dan staat
    "op voorraad" rechtsboven.
  - Anders de prijs op maat voor precies die maat: het aantal eenheden van 0,01 m² (breedte × lengte, rond diameter ×
    diameter, gewoon afgerond, minimaal 1) maal de prijs van de vorm. Dezelfde som en dezelfde maatgrenzen als op de
    productpagina.
  - Kan dat ook niet: de dichtstbijzijnde vaste maat, als breedte en lengte elk hoogstens 20 cm verschillen ("Wel in …");
    rond alleen bij rond, rechthoek alleen bij rechthoek of vierkant.
  - Kan het kleed helemaal niet in deze maat, dan blijft de kaart op zijn plek, de foto wordt lichter, en rechtsboven staat
    in één regel waarom ("Alleen rond", "Tot 350 × 500 cm").
  - De link van de kaart opent precies wat de kaart toont: de vaste maat (spoor=standaard&maat=…, met de kleur als die
    maat maar in een deel van de kleuren op voorraad ligt), of op maat met de maat al ingevuld.
  - De tekst van een kaart houdt zijn hoogte, zodat de rijen niet verspringen als de maat verandert.
  - Na elke ronde meldt het script "barlen:kaarten" met de telling; het maatvak toont die. Het maatvak meldt een nieuwe
    maat met "barlen:maat".
  Zonder dit script blijft de kaart zoals hij is: de prijs per m² of "vanaf".
*/
(function () {
  'use strict';
  var WACHT = 'pi-maat-wacht';
  var MIN = 50, MAX = 500;

  function klaar() { document.documentElement.classList.remove(WACHT); }
  function heel(v) { return v && /^[1-9][0-9]{1,3}$/.test(v) ? parseInt(v, 10) : null; }
  function uitAdres() {
    var q = new URLSearchParams(window.location.search);
    var b = heel(q.get('b')), l = heel(q.get('l')), d = heel(q.get('d'));
    if (b && l) return { rond: false, b: Math.min(b, l), l: Math.max(b, l) };
    if (d) return { rond: true, b: d, l: d };
    return null;
  }
  /* "170 × 230 cm" of "Ø 200 cm". Staat er iets achter (zoals een vorm), dan is het geen gewone maat. */
  function leesMaat(t) {
    t = String(t || '').replace(/ /g, ' ').trim();
    var m = t.match(/^(\d+)\s*[×x]\s*(\d+)\s*cm$/i);
    if (m) { var a = +m[1], c = +m[2]; return { rond: false, b: Math.min(a, c), l: Math.max(a, c) }; }
    m = t.match(/^Ø\s*(\d+)\s*cm$/i);
    if (m) return { rond: true, b: +m[1], l: +m[1] };
    return null;
  }
  function duizend(n) { return String(n).replace(/\B(?=(\d{3})+(?!\d))/g, '.'); }
  function maatTekst(S) { return S.rond ? 'Ø ' + S.b + ' cm' : S.b + ' × ' + S.l + ' cm'; }
  function geld(cent) {
    cent = Math.round(cent);
    var e = Math.floor(cent / 100), c = cent % 100;
    return '€' + duizend(e) + (c ? ',' + (c < 10 ? '0' : '') + c : '');
  }
  function esc(s) { return String(s).replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;').replace(/"/g, '&quot;'); }

  /* Maatgrenzen per vorm: "Rechthoek:min,max,max_breedte,max_lengte;…". Niets opgegeven: 50 tot 500 cm. */
  function grensVan(el, vorm) {
    var deel = String(el.getAttribute('data-pi-grens') || '').split(';').filter(function (x) { return x.indexOf(vorm + ':') === 0; })[0];
    var w = deel ? deel.slice(vorm.length + 1).split(',').map(function (x) { return x === '' ? null : Number(x); }) : [];
    var ok = function (v) { return typeof v === 'number' && isFinite(v); };
    if (!w.some(ok)) return { min: MIN, max: MAX, maxB: MAX, maxL: MAX };
    var mx = ok(w[1]) ? w[1] : (ok(w[3]) ? w[3] : MAX);
    return { min: ok(w[0]) ? w[0] : MIN, max: mx, maxB: ok(w[2]) ? w[2] : mx, maxL: ok(w[3]) ? w[3] : mx };
  }
  /* Op maat in deze maat? Rond als rond, vierkant als vierkant (anders als rechthoek), de rest als rechthoek. */
  function opMaat(el, S) {
    var p = String(el.getAttribute('data-pi-mw') || '').split(',').map(Number);
    var prijs = { Rechthoek: p[0] || 0, Vierkant: p[1] || 0, Rond: p[2] || 0 };
    var vorm = null;
    if (S.rond) vorm = prijs.Rond > 0 ? 'Rond' : null;
    else if (S.b === S.l && prijs.Vierkant > 0) vorm = 'Vierkant';
    else if (prijs.Rechthoek > 0) vorm = 'Rechthoek';
    if (!vorm) return { kan: false, reden: 'vorm' };
    var g = grensVan(el, vorm), binnen;
    if (vorm === 'Rond') binnen = S.b >= g.min && S.b <= g.max;
    else if (vorm === 'Vierkant') binnen = S.b >= g.min && S.b <= Math.min(g.max, g.maxB);
    else binnen = S.b >= g.min && S.l <= g.maxL && S.b <= g.maxB;
    if (!binnen) return { kan: false, reden: 'grens', vorm: vorm, g: g };
    return { kan: true, vorm: vorm, cent: Math.max(1, Math.round((S.b * S.l) / 100)) * prijs[vorm] };
  }
  function vasteMaten(el) {
    return String(el.getAttribute('data-pi-vast') || '').split('|').filter(Boolean).map(function (r) {
      var d = r.split('~'), i = d[0].indexOf('^');
      var maat = i > -1 ? d[0].slice(i + 1) : d[0];
      return { key: d[0], vorm: i > -1 ? d[0].slice(0, i) : '', maat: maat, S: leesMaat(maat), prijs: Number(d[1]) };
    });
  }
  function voorraad(el) {
    var per = {};
    String(el.getAttribute('data-pi-voorraad') || '').split('|').filter(Boolean).forEach(function (r) {
      var d = r.split('~');
      var x = per[d[0]] || (per[d[0]] = { prijs: null, kleuren: [], deny: 0 });
      var prijs = Number(d[1]), aantal = Number(d[2]);
      if (x.prijs === null || prijs < x.prijs) x.prijs = prijs;
      if (d[3] && x.kleuren.indexOf(d[3]) < 0) x.kleuren.push(d[3]);
      if (d[4] === 'd') x.deny += aantal;
    });
    return per;
  }
  function zelfde(v, S) { return !!v.S && v.S.rond === S.rond && v.S.b === S.b && v.S.l === S.l; }
  function vlak(v, S) { return !v.vorm || (S.rond ? v.vorm === 'Rond' : v.vorm === 'Rechthoek' || v.vorm === 'Vierkant'); }
  /* De dichtstbijzijnde vaste maat: breedte en lengte elk hoogstens 20 cm ernaast, dezelfde soort vorm. Bij gelijke
     afstand eerst een maat op voorraad, dan de laagste prijs. */
  function dichtstbij(vast, S, op) {
    var best = null;
    vast.forEach(function (v) {
      if (!v.S || v.S.rond !== S.rond || !vlak(v, S)) return;
      var db = Math.abs(v.S.b - S.b), dl = Math.abs(v.S.l - S.l);
      if (db > 20 || dl > 20) return;
      var x = { v: v, sc: db + dl, op: op[v.key] ? 1 : 0 };
      if (!best || x.sc < best.sc || (x.sc === best.sc && (x.op > best.op || (x.op === best.op && v.prijs < best.v.prijs)))) best = x;
    });
    return best ? best.v : null;
  }
  /* Waarom een kleed niet in deze maat kan, in een paar woorden. */
  function reden(el, S, om, vast) {
    if (!el.getAttribute('data-pi-mw')) return vast.length ? 'Alleen vaste maten' : '';
    if (om.reden === 'vorm') return S.rond ? 'Niet rond' : 'Alleen rond';
    var g = om.g;
    if (om.vorm === 'Rond') return 'Tot Ø ' + g.max + ' cm';
    if (om.vorm === 'Vierkant') { var z = Math.min(g.max, g.maxB); return 'Tot ' + z + ' × ' + z + ' cm'; }
    return 'Tot ' + g.maxB + ' × ' + g.maxL + ' cm';
  }

  /* De kaart voor maat S: soort (vast, opmaat, dichtbij of niet), de tekst en het adres van de link. Null: niets bekend,
     de kaart blijft zoals hij is. */
  function reken(el, S) {
    var mw = String(el.getAttribute('data-pi-mw') || '');
    if (mw === '?') return null;
    var om = mw ? opMaat(el, S) : { kan: false, reden: 'geen' }, kan = om.kan;
    var vast = vasteMaten(el), op = voorraad(el);
    var gelijk = vast.filter(function (v) { return zelfde(v, S); });
    var kies = function (lijst) { return lijst.filter(function (v) { return op[v.key]; })[0] || lijst[0] || null; };
    var vm = kies(gelijk.filter(function (v) { return vlak(v, S); })) || (kan ? null : kies(gelijk));
    var dichtbij = false;
    if (!vm && !kan) { vm = dichtstbij(vast, S, op); dichtbij = !!vm; }
    if (!vm && !kan) {
      var waarom = reden(el, S, om, vast);
      if (!waarom) return null;
      return { soort: 'niet', meta: '<span class="pi-reden">' + esc(waarom) + '</span>', prijs: '<span class="pi-niet-tekst">Niet in deze maat</span>', link: null };
    }
    var delen = [], info = '', prijs, link, kleur = '';
    if (vm && op[vm.key]) {
      var x = op[vm.key], kl = Number(el.getAttribute('data-pi-kleuren')) || 0;
      if (x.kleuren.length && x.kleuren.length < kl) kleur = x.kleuren[0];
      info = 'op voorraad';
      if (el.hasAttribute('data-pi-laatste') && x.deny > 0 && x.deny <= 5) info += ' (nog ' + x.deny + ')';
    }
    if (kan) delen.push('<span class="pi-mw">Maatwerk</span>');
    if (info) delen.push('<span class="pi-vr">' + esc(info) + '</span>');
    if (vm) {
      var bedrag = op[vm.key] && op[vm.key].prijs !== null ? op[vm.key].prijs : vm.prijs;
      var wat = vm.maat + (vm.vorm && !vlak(vm, S) ? ', ' + vm.vorm : '');
      prijs = dichtbij
        ? '<span class="pi-klein">Wel in ' + esc(vm.maat) + ' · </span><span class="pi-bedrag">' + geld(bedrag) + '</span>'
        : '<span class="pi-bedrag">' + geld(bedrag) + '</span><span class="pi-klein"> · ' + esc(wat) + '</span>';
      link = { spoor: 'standaard', maat: vm.maat, vorm: vm.vorm, kleur: kleur };
    } else {
      prijs = '<span class="pi-bedrag">' + geld(om.cent) + '</span><span class="pi-klein"> · ' + esc(maatTekst(S)) + '</span>';
      link = { spoor: 'maat', vorm: om.vorm, S: S };
    }
    return { soort: vm ? (dichtbij ? 'dichtbij' : 'vast') : 'opmaat', meta: delen.join('<span class="pi-sep"> · </span>'), prijs: prijs, link: link };
  }

  /* Het adres van de link bij een uitkomst; zonder uitkomst het oorspronkelijke adres. */
  function adresVan(origineel, link) {
    if (!link) return origineel;
    var pad = String(origineel).split('#')[0].split('?')[0];
    var q = new URLSearchParams();
    q.set('spoor', link.spoor);
    if (link.spoor === 'standaard') {
      q.set('maat', link.maat);
      if (link.vorm) q.set('vorm', link.vorm);
      if (link.kleur) q.set('kleur', link.kleur);
    } else {
      q.set('vorm', link.vorm);
      if (link.vorm === 'Rond') q.set('d', link.S.b);
      else if (link.vorm === 'Vierkant') q.set('b', link.S.b);
      else { q.set('b', link.S.b); q.set('l', link.S.l); }
    }
    return pad + '?' + q.toString().replace(/\+/g, '%20');
  }
  function zetLinks(el, link) {
    var kaart = el.closest('li') || el.parentNode;
    if (!kaart) return;
    var as = kaart.querySelectorAll('a[href*="/products/"]');
    for (var i = 0; i < as.length; i++) {
      var a = as[i];
      if (a.piHref === undefined) a.piHref = a.getAttribute('href');
      var nieuw = adresVan(a.piHref, link);
      if (a.getAttribute('href') !== nieuw) a.setAttribute('href', nieuw);
    }
  }
  /* De hoogte van de tekst vastzetten op die zonder maat, zodat er niets verspringt. */
  function vastZetten(el) {
    if (el.piSlot) return;
    el.style.minHeight = el.getBoundingClientRect().height + 'px';
    el.piSlot = true;
  }
  /* Bij veel kaarten tegelijk: eerst alle hoogtes lezen, dan pas vastzetten. Zo meet de browser de pagina één keer en
     niet na elke kaart opnieuw; de eerste prijzen staan er dan meteen. */
  function allesVastZetten(kaarten, adres) {
    var h = [], i;
    for (i = 0; i < kaarten.length; i++) {
      var el = kaarten[i];
      h.push(!el.piSlot && (adres || leesMaat(el.getAttribute('data-pi-kies'))) ? el.getBoundingClientRect().height : 0);
    }
    for (i = 0; i < kaarten.length; i++) {
      if (!h[i]) continue;
      kaarten[i].style.minHeight = h[i] + 'px';
      kaarten[i].piSlot = true;
    }
  }
  function losMaken() {
    var kaarten = document.querySelectorAll('[data-pi-maatdata]');
    for (var i = 0; i < kaarten.length; i++) {
      var el = kaarten[i];
      if (!el.piSlot) continue;
      if (el.piEerst) {
        el.querySelector('[data-pi-wissel="meta"]').innerHTML = el.piEerst.meta;
        el.querySelector('[data-pi-wissel="prijs"]').innerHTML = el.piEerst.prijs;
        el.removeAttribute('data-pi-gekozen');
      }
      el.style.minHeight = '';
      el.piSlot = false;
    }
  }

  function pas(el, adres) {
    var meta = el.querySelector('[data-pi-wissel="meta"]'), prijs = el.querySelector('[data-pi-wissel="prijs"]');
    if (!meta || !prijs) return null;
    if (!el.piEerst) el.piEerst = { meta: meta.innerHTML, prijs: prijs.innerHTML };
    var S = adres || leesMaat(el.getAttribute('data-pi-kies'));
    if (S) vastZetten(el);
    var r = S ? reken(el, S) : null;
    var kaart = el.closest('li');
    if (!r) {
      if (meta.innerHTML !== el.piEerst.meta) meta.innerHTML = el.piEerst.meta;
      if (prijs.innerHTML !== el.piEerst.prijs) prijs.innerHTML = el.piEerst.prijs;
      el.removeAttribute('data-pi-gekozen');
      if (kaart) kaart.classList.remove('pi-niet');
      zetLinks(el, null);
      return null;
    }
    if (meta.innerHTML !== r.meta) meta.innerHTML = r.meta;
    if (prijs.innerHTML !== r.prijs) prijs.innerHTML = r.prijs;
    el.setAttribute('data-pi-gekozen', maatTekst(S));
    if (kaart) kaart.classList.toggle('pi-niet', r.soort === 'niet');
    zetLinks(el, r.link);
    return r;
  }
  function alles(binnen) {
    var adres = uitAdres();
    var kaarten = (binnen || document).querySelectorAll('[data-pi-maatdata]');
    allesVastZetten(kaarten, adres);
    var totaal = 0, kan = 0;
    for (var i = 0; i < kaarten.length; i++) {
      var r = pas(kaarten[i], adres);
      totaal++;
      if (r && (r.soort === 'vast' || r.soort === 'opmaat')) kan++;
    }
    if (!binnen) document.dispatchEvent(new CustomEvent('barlen:kaarten', { detail: { maat: adres, totaal: totaal, kan: kan } }));
  }

  try { alles(); } finally { klaar(); }
  /* De knop voor meer kleden haalt de volgende pagina op en zet daarna het adres van de knop in de adresbalk. Dat adres
     kent de maat niet; daarom krijgt de knop de maat mee vlak voordat de klik verwerkt wordt. */
  document.addEventListener('click', function (e) {
    var a = e.target && e.target.closest ? e.target.closest('#load-more-button[data-next], #load-more-button[data-prev]') : null;
    var href = a ? a.getAttribute('href') : '';
    if (!href || href.charAt(0) === '#') return;
    var nu = new URLSearchParams(window.location.search), u;
    try { u = new URL(href, window.location.href); } catch (x) { return; }
    var anders = false;
    ['b', 'l', 'd'].forEach(function (k) {
      var v = nu.get(k);
      if (v && u.searchParams.get(k) !== v) { u.searchParams.set(k, v); anders = true; }
      else if (!v && u.searchParams.has(k)) { u.searchParams.delete(k); anders = true; }
    });
    if (anders) a.setAttribute('href', u.pathname + u.search + u.hash);
  }, true);
  /* Terug naar de goede kaart. De knop voor meer kleden zet de laatst geladen pagina in het adres, en na Terug toont de
     server alleen die pagina. Een klik op een kaart zet daarom eerst de pagina van die kaart in het adres (data-bc-pagina;
     de maat en de filters blijven staan) en onthoudt welke kaart het was, ook bij een klik op de naam. Daar scrolt het
     thema na Terug naartoe. */
  document.addEventListener('click', function (e) {
    if (e.button > 0 || e.metaKey || e.ctrlKey || e.shiftKey || e.altKey) return;
    var a = e.target && e.target.closest ? e.target.closest('#collection a[href*="/products/"]:not([data-quickshop])') : null;
    var kaart = a ? a.closest('[data-bc-pagina]') : null;
    if (!kaart) return;
    var p = parseInt(kaart.getAttribute('data-bc-pagina'), 10), q = new URLSearchParams(window.location.search);
    if (p >= 1 && (q.get('page') || '1') !== String(p)) {
      if (p > 1) q.set('page', p); else q.delete('page');
      var s = q.toString();
      try { history.replaceState(history.state, '', window.location.pathname + (s ? '?' + s : '') + window.location.hash); } catch (x) {}
    }
    try { localStorage.setItem('loadMoreItemClicked', a.getAttribute('href')); } catch (x) {}
  }, true);
  /* Komt de pagina met Terug ongewijzigd uit het geheugen van de browser, dan staat alles nog op zijn plek en hoeft het
     thema de kaart niet meer op te zoeken. Anders scrolde een volgende collectie met hetzelfde kleed er later naartoe. */
  window.addEventListener('pageshow', function (e) {
    if (!e.persisted) return;
    try { localStorage.removeItem('loadMoreItemClicked'); } catch (x) {}
  });
  window.addEventListener('popstate', function () { alles(); });
  document.addEventListener('barlen:maat', function () { alles(); });
  var breedte = window.innerWidth, rust = null;
  window.addEventListener('resize', function () {
    clearTimeout(rust);
    rust = setTimeout(function () { if (window.innerWidth === breedte) return; breedte = window.innerWidth; losMaken(); alles(); }, 200);
  });
  if (window.MutationObserver) {
    new MutationObserver(function (lijst) {
      var bij = false;
      for (var i = 0; i < lijst.length; i++) {
        var nieuw = lijst[i].addedNodes;
        for (var j = 0; j < nieuw.length; j++) {
          var n = nieuw[j];
          if (n.nodeType !== 1) continue;
          if (n.hasAttribute('data-pi-maatdata')) { if (!n.piEerst) { pas(n, uitAdres()); bij = true; } }
          else if (n.querySelector('[data-pi-maatdata]')) { alles(n); bij = true; }
        }
      }
      if (bij) alles();
    }).observe(document.body, { childList: true, subtree: true });
  }
})();
